import React from 'react';
import { Box } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';

export const OptionLabel = ({
  label,
  showPicklistIcon,
}: {
  label: string;
  showPicklistIcon: boolean;
}) => {
  if (!showPicklistIcon) return <>{label}</>;

  return (
    <Box className="inline-flex items-center gap-1">
      <span>{label}</span>
      <span className="sr-only">Mapped Clio Manage option</span>
      <LinkIcon
        data-testid="picklist-appended-icon"
        fontSize="inherit"
        aria-hidden="true"
        sx={{ opacity: 0.7 }}
      />
    </Box>
  );
};
